import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import PropTypes from 'prop-types';

import { Button } from 'react-bootstrap';
import GenericTable from 'componentes/generic/GenericTable.js';

const CpsTable = ({ cps, setIdCp, setOpenModal }) => {
  const columns = [
    {
      accessorKey: 'municipio',
      header: 'Municipio',
      headerProps: { style: { minWidth: '200px' }, className: 'ps-5' },
      cellProps: { className: 'ps-5' }
    },
    {
      accessorKey: 'estado',
      header: 'Estado',
      headerProps: { style: { minWidth: '200px' }, className: 'ps-5' },
      cellProps: { className: 'ps-5' }
    },
    {
      accessorKey: 'codigopostal',
      header: 'Codigo Postal',
      headerProps: { style: { minWidth: '200px' }, className: 'ps-5' },
      cellProps: { className: 'ps-5' }
    },
    {
      accessorKey: 'idcodigopostal',
      header: '',
      disableSortBy: true,
      cellProps: {
        className: 'text-end'
      },
      cell: ({ row: { original } }) => {
        const { idcodigopostal } = original;

        return (
          <>
            <Button
              variant="falcon-default"
              size="sm"
              title="Editar"
              onClick={() => {
                setIdCp(idcodigopostal);
                setOpenModal(true);
              }}
            >
              <FontAwesomeIcon icon="pencil-alt" />
            </Button>
            {/* <Button
                variant="falcon-default"
                size="sm"
                title="Eliminar"
                onClick={() => {
                  setIdMunicipioToDelete(idmunicipio);
                  setOpenConfirm(true);
                }}
              >
                <FontAwesomeIcon icon="trash-alt" />
              </Button> */}
          </>
        );
      }
    }
  ];

  return (
    <>
      <GenericTable
        data={cps}
        title="Codigos Postales"
        columns={columns}
        addAction={() => {
          setIdCp(0);
          setOpenModal(true);
        }}
      ></GenericTable>
    </>
  );
};

CpsTable.propTypes = {
  cps: PropTypes.array.isRequired,
  setIdCp: PropTypes.func.isRequired,
  setOpenModal: PropTypes.func.isRequired
};

export default CpsTable;
